<template>
<van-dialog v-model:show="show" title="确认企业信息" show-cancel-button @confirm="submit" @cancel="cancel">
  <van-form>
  <van-cell-group inset>
    <van-field
      v-model="formCompany.name"
      name="企业名称"
      placeholder="企业名称"
    />
    <van-field
      v-model="formCompany.phone"
      name="联系号码"
      placeholder="联系号码"
    />
  </van-cell-group>
</van-form>
</van-dialog>
</template>

<script>
export default {
  name: "DeclareModel",
  props:{
      show: false,
      formCompany: {},
  },
  data(){
    return{}
  },

  mounted(){
  },

  methods:{
      submit(){
          this.$emit('declareSubmit',this.formCompany)
      },
      cancel(){
          this.$emit('declareCancel')
      },
  }

}
</script>

<style lang="scss" scoped>
  .content {
    padding: 16px 16px 16px;
  font-size: 12px;
  .policy-file-item{
    padding: 15px 0 15px 12px;
    margin-right: 15px;
    &.has-sider{
      margin-right: 0;
    }
  }
  .img-box{
    width: 73px;
    height: 73px;
    border-radius: 6px;
    position: relative;
    margin-right: 20px;
    img{
      width: 100%;
      height: 100%;
      background-size: cover;
    }
    .vip-img{
      position: absolute;
      z-index:10;
      bottom: 0;
      left: -13px;
      width: 25px;
      height: 21px;
      background-size: contain;
      border: 1px solid red;
    }
    .vip-box{
      position: absolute;
      z-index: 5;
      bottom: 0;
      left: 0;
      width: 60px;
      height: 14px;
      background: linear-gradient(88deg, #C99654 0%, #FEE5AF 100%);
      color: #fff;
      text-align: center;
      line-height: 14px;
      padding-left: 13px;
      span{
        color: #FF0000;
        font-size: 14px;
        font-weight: 600;
        margin: 0 3px;
      }
    }
    }

.policy-file-item-content{
  padding: 0;
  margin: 0;
}
.policy-file-item-footer{
  padding: 7px 0 0;
  >div{
    width: 100%;
  }
}
    .policy-file-item-title{
      font-size: 14px;
    }
    
  
}
</style>
